import { cn } from "@theprelude/core";
import { CheckmarkIcon } from "@theprelude/ds";

interface StatusIconProps {
  variant: "success" | "pending";
  className?: string;
}

export const StatusIcon = ({ variant, className }: StatusIconProps) => {
  return (
    <div
      className={cn(
        "flex h-5 w-5 items-center justify-center rounded-full",
        variant === "success" ? "bg-status-green" : "bg-status-yellow",
        className,
      )}
    >
      {variant === "success" ? (
        <CheckmarkIcon className="h-3 w-3 text-white" />
      ) : (
        <div className="h-[2px] w-2 bg-white" />
      )}
    </div>
  );
};
